module.exports = {"payment_schedule":"Payment Schedule","one_time_payment":"Make Payment"}